module.exports = __webpack_public_path__ + "img/img_size1_test.86219a70.png";